import React, {useEffect} from "react";
import {Button, Modal} from "react-bootstrap";
import BaseModal from "../BaseModal";
import logoSite from '../../../../../images/logo/logo-site-colors.png';
import {useCookies} from 'react-cookie';
import {isIOS} from 'react-device-detect';
import {actionChangeDataModalPwaIsIos} from "../../../../../redux/actions/modals/modalPwaIsIos";
import {useDispatch, useSelector} from "react-redux";
import {FaExternalLinkAlt, FaPlus, FaPlusSquare} from "react-icons/all";

const ModalPwaIsIos = () => {
    const dispatch = useDispatch();
    const {statusShow} = useSelector(state => state.modalPwaIsIos);
    const [cookies, setCookie] = useCookies(['showModalPwaIsIos']);

    const handleClose = () => {
        dispatch(actionChangeDataModalPwaIsIos('statusShow', false));
    }

    const showModal = () => {
        handleSetCookie();
        dispatch(actionChangeDataModalPwaIsIos('statusShow', true));
    }

    const handleSetCookie = () => {
        let d = new Date();
        d.setTime(d.getTime() + (24 * (60 * 60 * 1000)));
        setCookie('showModalPwaIsIos', true, {path: "/", expires: d});
    }
    useEffect(() => {
        if (isIOS && !isRunningStandalone() && !cookies.showModalPwaIsIos) {
            showModal();
        }
        // eslint-disable-next-line
    }, []);

    const isRunningStandalone = () => {
        return (window.matchMedia('(display-mode: standalone)').matches);
    }


    return (
        <BaseModal title={''} show={statusShow}
                   dialogClassName={'cm-modal-is-ios'}
                   handleClose={handleClose}>
            <Modal.Body>
                <div className='box-body-modal-is-ios'>
                    <div className='box-img-modal-is-ios border-bottom'>
                        <img src={logoSite} alt="LOGO-SITE" width={60} height={60}/>
                        <p>وب اپلیکیشن فروت مروت! را به صفحه اصلی موبایل خود اضافه کنید.</p>
                    </div>
                    <div className='box-data-modal-is-ios'>
                        <ul>
                            <li>
                                <FaExternalLinkAlt className='icon-list-modal-is-ios'/>
                                <p>1 - در نوار پایین روی دکمه <b>Share</b> بزنید.</p>
                            </li>
                            <li>
                                <FaPlusSquare className='icon-list-modal-is-ios'/>
                                <p>2 - در منوی باز شده، در قسمت پایین، گزینه <b>Add to Home Screen</b> را انتخاب کنید.
                                </p>
                            </li>
                            <li>
                                <FaPlus className='icon-list-modal-is-ios'/>
                                <p>3 - در مرحله بعد در قسمت بالا روی <b>Add</b> بزنید.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" className={'base-btn-green'} block onClick={handleClose}>
                    <span>متوجه شدم</span>
                </Button>
            </Modal.Footer>
        </BaseModal>
    );
}

export default ModalPwaIsIos;
